import { lazy } from "react"
import { Navigate } from "react-router-dom"
import { Root } from "src/shared/components"
import PermissionRoute from "../permission-route"

const PartnersList = lazy(() => import("src/modules/customers-partners/partners/pages/PartnerList"))
const CreateCustomer = lazy(() => import("src/modules/customers-partners/customers/pages/CreateCustomer"))
const UpdateCustomer = lazy(() => import("src/modules/customers-partners/customers/pages/UpdateCustomer"))
const CustomersList = lazy(() => import("src/modules/customers-partners/customers/pages/CustomersList"))

const customerPartnerRoutes = {
  path: "customers-partners",
  element: <Root />,
  children: [
    {
      index: true,
      element: <Navigate to="customers" />
    },
    {
      path: "customers",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="customers-partners:customer:customer-list-read">
              <CustomersList />
            </PermissionRoute>
          )
        },
        {
          path: "create",
          element: (
            <PermissionRoute permission="customers-partners:customer:customer-list-read">
              <CreateCustomer />
            </PermissionRoute>
          )
        },
        {
          path: "update/:id",
          element: (
            <PermissionRoute permission="customers-partners:customer:customer-list-read">
              <UpdateCustomer />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "partners",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="customers-partners:partner:partner-list-read">
              <PartnersList />
            </PermissionRoute>
          )
        }
      ]
    }
  ]
}

export default customerPartnerRoutes
